export const PLATFORMS = {
  er:   { name: "EntryRate",        code: "ER", color: "var(--plat-er)",   fee: "0%"  },
  skid: { name: "Skiddle",          code: "SK", color: "var(--plat-skid)", fee: "10%" },
  dice: { name: "DICE",             code: "DC", color: "var(--plat-dice)", fee: "11%" },
  fats: { name: "Fatsoma",          code: "FA", color: "var(--plat-fats)", fee: "9%"  },
  ra:   { name: "Resident Advisor", code: "RA", color: "var(--plat-ra)",   fee: "8%"  },
  evbr: { name: "Eventbrite",       code: "EB", color: "var(--plat-evbr)", fee: "12%" },
  tm:   { name: "Ticketmaster",     code: "TM", color: "var(--plat-tm)",   fee: "15%" },
};

export const PLATFORM_KEYS = Object.keys(PLATFORMS);

export const STATUS_PILL = {
  live:  { cls: "live",  label: "On sale" },
  sold:  { cls: "sold",  label: "Selling fast" },
  soon:  { cls: "soon",  label: "Pre-sale" },
  draft: { cls: "draft", label: "Draft" },
  alert: { cls: "alert", label: "Low pace" },
};

// stable mock thumbnails — gradient SVGs as data URIs
export function thumb(seed, hue1, hue2) {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 60'><defs><linearGradient id='g${seed}' x1='0' x2='1' y1='0' y2='1'><stop offset='0' stop-color='hsl(${hue1},80%,55%)'/><stop offset='1' stop-color='hsl(${hue2},90%,30%)'/></linearGradient></defs><rect width='60' height='60' fill='url(%23g${seed})'/><text x='50%' y='58%' text-anchor='middle' fill='rgba(0,0,0,.55)' font-family='monospace' font-size='28' font-weight='700'>${seed}</text></svg>`;
  return "data:image/svg+xml;utf8," + svg.replace(/#/g, "%23");
}

export const HUE = [
  "28,290","340,40","180,260","65,300","210,350","12,200","290,180",
  "45,15","260,200","160,340","300,60","20,290","100,280","220,330"
];

export const EVENTS = [
  { id:"EV-2104", code:"BG", title:"Breadgang Live · Vol. 014", sub:"Crazylegs + Ash Henson + RBL", venue:"The Marble Factory", city:"Bristol", date:"Fri 16 May", time:"22:00 → 04:00",
    status:"live", cap:1200, hue:"28,290",
    sales:{ er:312, skid:418, dice:255, fats:96, ra:62, evbr:0, tm:0 }, price:18.5,
    activity:[
      { t:"21:48", e:"Sale · Skiddle",       v:"+£18.50" },
      { t:"21:46", e:"Sale · DICE x2",       v:"+£37.00" },
      { t:"21:44", e:"Sale · EntryRate",     v:"+£18.50" },
      { t:"21:39", e:"Refund · Fatsoma",     v:"-£18.50", neg:true },
      { t:"21:35", e:"Sale · Skiddle x4",    v:"+£74.00" },
    ],
  },
  { id:"EV-2105", code:"FR", title:"Frequencies · Closing Party", sub:"Sherelle (3hr set) · Pessimist", venue:"Strange Brew", city:"Bristol", date:"Sat 17 May", time:"23:00 → 06:00",
    status:"sold", cap:480, hue:"340,40",
    sales:{ er:142, skid:118, dice:155, fats:0, ra:65, evbr:0, tm:0 }, price:22 },
  { id:"EV-2107", code:"TC", title:"Teachings in Dub", sub:"Iration Steppas · Channel One", venue:"The Trinity Centre", city:"Bristol", date:"Sat 24 May", time:"22:30 → 04:00",
    status:"live", cap:900, hue:"180,260",
    sales:{ er:212, skid:298, dice:0, fats:154, ra:0, evbr:88, tm:0 }, price:16 },
  { id:"EV-2108", code:"NV", title:"Night Vibes · Drum & Bass Special", sub:"Hybrid Minds · DJ Marky · Lens", venue:"Motion", city:"Bristol", date:"Sun 25 May", time:"22:00 → 05:00",
    status:"live", cap:2400, hue:"65,300",
    sales:{ er:520, skid:842, dice:401, fats:288, ra:0, evbr:0, tm:215 }, price:24 },
  { id:"EV-2110", code:"SQ", title:"Squared Circle · House night", sub:"Local DJs + open decks", venue:"The Crofters Rights", city:"Bristol", date:"Thu 29 May", time:"21:00 → 03:00",
    status:"soon", cap:240, hue:"210,350",
    sales:{ er:48, skid:22, dice:14, fats:0, ra:0, evbr:0, tm:0 }, price:8 },
  { id:"EV-2113", code:"OL", title:"Outlook Pre-Party", sub:"Mungo's Hi Fi soundsystem", venue:"Lakota", city:"Bristol", date:"Fri 6 Jun", time:"22:00 → 06:00",
    status:"live", cap:1100, hue:"12,200",
    sales:{ er:188, skid:262, dice:198, fats:120, ra:55, evbr:0, tm:0 }, price:19.5 },
  { id:"EV-2115", code:"WL", title:"Warehouse Lates · 008", sub:"Surusinghe · Bakey · Anz", venue:"Loco Klub", city:"Bristol", date:"Sat 14 Jun", time:"23:00 → 07:00",
    status:"live", cap:1400, hue:"290,180",
    sales:{ er:312, skid:402, dice:288, fats:118, ra:202, evbr:0, tm:0 }, price:25 },
  { id:"EV-2118", code:"GO", title:"GOAT Festival · Day One", sub:"4 stages · 22 acts", venue:"Eastville Park", city:"Bristol", date:"Sat 21 Jun", time:"12:00 → 22:00",
    status:"live", cap:8000, hue:"45,15",
    sales:{ er:1240, skid:2105, dice:984, fats:612, ra:418, evbr:301, tm:418 }, price:42 },
  { id:"EV-2121", code:"RT", title:"Ransom Note · 10 Year Birthday", sub:"Andrew Weatherall tribute set", venue:"YES Manchester", city:"Manchester", date:"Fri 4 Jul", time:"22:00 → 04:00",
    status:"live", cap:600, hue:"260,200",
    sales:{ er:88, skid:142, dice:152, fats:0, ra:108, evbr:0, tm:0 }, price:21 },
  { id:"EV-2123", code:"DN", title:"Drumcode UK", sub:"Adam Beyer · Layton Giordani", venue:"Printworks · East Wing", city:"London", date:"Sat 12 Jul", time:"22:00 → 06:00",
    status:"sold", cap:5000, hue:"160,340",
    sales:{ er:520, skid:1488, dice:1612, fats:0, ra:1088, evbr:292, tm:0 }, price:38 },
  { id:"EV-2126", code:"AF", title:"Afters at the Old Crown", sub:"Selectors · all-vinyl", venue:"Old Crown Courts", city:"Bristol", date:"Sun 27 Jul", time:"04:00 → 11:00",
    status:"soon", cap:320, hue:"300,60",
    sales:{ er:42, skid:0, dice:0, fats:0, ra:0, evbr:0, tm:0 }, price:12 },
  { id:"EV-2128", code:"TT", title:"Tomorrowland Warmup · BS1", sub:"Five-act bill", venue:"SWX", city:"Bristol", date:"Fri 1 Aug", time:"22:00 → 04:00",
    status:"alert", cap:1600, hue:"20,290",
    sales:{ er:64, skid:84, dice:40, fats:0, ra:0, evbr:0, tm:0 }, price:28, alert:"low pace · 11.7% sold @ T-90d" },
  { id:"EV-2131", code:"DR", title:"Daydream · Open-air series", sub:"Three rooms · Castle Park", venue:"Castle Park", city:"Bristol", date:"Sat 9 Aug", time:"14:00 → 22:00",
    status:"draft", cap:3000, hue:"100,280",
    sales:{ er:0, skid:0, dice:0, fats:0, ra:0, evbr:0, tm:0 }, price:32 },
  { id:"EV-2134", code:"FF", title:"Field Day · After-after", sub:"TBA", venue:"Corsica Studios", city:"London", date:"Sun 17 Aug", time:"23:00 → 08:00",
    status:"draft", cap:500, hue:"220,330",
    sales:{ er:0, skid:0, dice:0, fats:0, ra:0, evbr:0, tm:0 }, price:18 },
];
